import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Footer from '../../components/feature/Footer';

const quickSalePosts = [
  {
    title: "How to Find an Investor to Buy My House",
    excerpt:
      "Discover the top ways to find real estate investors in El Paso who buy houses fast for cash—no repairs, no agents, no waiting.",
    category: "INVESTOR BUYERS",
    readTime: "22 min read",
    link: "/quick-sale/how-to-find-an-investor-to-buy-my-house",
    image:
      "https://public.readdy.ai/ai/img_res/62bd4197e5bd385b7b3211ec49a24b58.jpg",
  },
  {
    title: "Cash Sales Get You a Quick Close: How to Sell Your House Fast in El Paso",
    excerpt:
      "Learn how a cash sale closes in 7–14 days, skips banks and inspections, and puts money in your hands fast—El Paso quick cash buyers explained.",
    category: "QUICK CLOSE",
    readTime: "15 min read",
    link: "/quick-sale/cash-sale-quick-close",
    image:
      "https://readdy.ai/api/search-image?query=homeowner%20receiving%20cash%20payment%20and%20house%20keys%20at%20closing%20table%20in%20El%20Paso%20Texas%2C%20fast%20property%20sale%20transaction%20with%20documents%20signed%2C%20warm%20professional%20office%20lighting%20...&width=800&height=500&seq=qs-cashclose-card-001&orientation=landscape",
  },
  {
    title: "Sell a House With Previous Animal Hoarding: Get Cash As-Is, No Judgment",
    excerpt:
      "Own a home damaged by animal hoarding or pet waste? Sell as-is for cash in El Paso—no cleaning, no repairs, no questions asked.",
    category: "AS-IS SALE",
    readTime: "18 min read",
    link: "/quick-sale/sell-house-with-previous-animal-hoarding",
    image:
      "https://public.readdy.ai/ai/img_res/edited_79f1731039ff52220cb453f267a9a0c2_6ed8b103.jpg",
  },
];

export default function QuickSaleCategoryPage() {
  useEffect(() => {
    // Ensure the page starts at the top when navigated to
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-black rounded-lg flex items-center justify-center">
              <i className="ri-home-4-fill text-[#D4AF37] text-xl"></i>
            </div>
            <span className="text-xl font-bold text-black">Cash For Houses El Paso</span>
          </Link>
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer hidden md:block"
            >
              Home
            </Link>
            <Link
              to="/get-cash"
              className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer hidden md:block"
            >
              Blog
            </Link>
            <a
              href="tel:9157457883"
              className="px-6 py-3 bg-[#D4AF37] text-white font-semibold rounded-full hover:bg-[#B8941F] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>915-745-7883
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section
        className="pt-32 pb-16 relative overflow-hidden"
        style={{
          backgroundImage: `url("https://readdy.ai/api/search-image?query=abandoned%20distressed%20house%20with%20overgrown%20grass%20boarded%20up%20windows%20peeling%20paint%20neglected%20property%20exterior%20in%20El%20Paso%20Texas%20neighborhood%2C%20dark%20moody%20overcast%20sky%2C%20weathered%20wood%20siding%20cracked%20concrete%20driveway%2C%20dramatic%20wide%20angle%20photography%20showing%20full%20property%20decay%20and%20urban%20blight&width=1600&height=700&seq=qs-hero-bg-001&orientation=landscape")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70"></div>

        <div className="relative z-10 max-w-6xl mx-auto px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors mb-6 cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i> Back to Home
          </Link>
          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block px-4 py-1.5 bg-[#D4AF37]/25 text-[#D4AF37] text-xs font-semibold uppercase tracking-widest rounded-full mb-4">
              Quick Sale Guides
            </span>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Quick Sale Resources</h1>
            <p className="text-xl text-white/85 leading-relaxed">
              Practical guides for El Paso homeowners who need to sell fast—find investors, understand cash offers, and close on
              your timeline.
            </p>
          </div>
        </div>
      </section>

      {/* Posts Grid */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-center justify-between mb-10">
            <h2 className="text-2xl font-bold text-black">
              All Articles{' '}
              <span className="text-gray-400 font-normal text-lg ml-2">{quickSalePosts.length} posts</span>
            </h2>
          </div>

          <div className="space-y-10">
            {quickSalePosts.map((post, index) => (
              <article
                key={index}
                className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <Link to={post.link} className="grid grid-cols-1 lg:grid-cols-2 gap-0 cursor-pointer">
                  <div className="h-64 lg:h-auto overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                      onError={(e) => {
                        // Fallback image in case the generated URL fails
                        e.currentTarget.src = '/fallback-image.jpg';
                      }}
                    />
                  </div>
                  <div className="p-10 flex flex-col justify-center">
                    <span className="inline-block px-4 py-2 bg-[#D4AF37] text-white text-xs uppercase font-semibold rounded-full mb-4 w-fit">
                      {post.category}
                    </span>
                    <h2 className="text-2xl md:text-3xl font-bold text-black mb-4 leading-tight hover:text-gray-700 transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-base text-gray-600 mb-6 leading-relaxed">{post.excerpt}</p>
                    <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
                      <i className="ri-time-line"></i>
                      <span>{post.readTime}</span>
                    </div>
                    <span className="text-base font-semibold text-black underline inline-flex items-center gap-2 hover:gap-3 transition-all cursor-pointer">
                      Read Full Article <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Also Browse */}
      <section className="py-16 bg-[#FAF8F5]">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h3 className="text-2xl font-bold text-black mb-3">Looking for More Guides?</h3>
          <p className="text-gray-600 mb-8">
            Browse our full library of El Paso real estate articles covering foreclosure, inherited homes, repairs, and more.
          </p>
          <Link
            to="/get-cash"
            className="inline-flex items-center gap-2 px-8 py-4 bg-black text-white font-semibold rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Articles <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#2C2C2C] py-24">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Ready to Sell Fast?</h2>
          <p className="text-xl text-white/80 mb-10">Get a fair cash offer today — no repairs, no fees, no hassle.</p>
          <a
            href="tel:9157457883"
            className="inline-block text-5xl font-bold text-white mb-8 hover:text-[#D4AF37] transition-colors cursor-pointer"
          >
            915-745-7883
          </a>
          <div>
            <Link
              to="/#contact-form"
              className="inline-block px-12 py-4 bg-white text-black text-lg font-semibold rounded-full hover:scale-105 hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer"
            >
              Get Your Cash Offer
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
